import { ChangeDetectorRef, Component, Input, Optional, QueryList, ViewChildren } from '@angular/core';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { Columns, CrudRevisionEntity } from '@scisys-uim/uim-common';


@Component({
  selector: 'app-audit-revision-info-columns',
  templateUrl: './audit-revision-info-columns.component.html',
  styleUrls: ['./audit-revision-info-columns.component.scss']
})
export class AuditRevisionInfoColumns {
  @ViewChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  constructor(@Optional() public table: MatTable<any>, private cdRef: ChangeDetectorRef) { }

  @Input()
  revisionEntityGetter: (record: any) => CrudRevisionEntity;

  @Input()
  columns: Columns;

  @Input()
  cellClassFn = (element: any, fieldName: any) => { };

  ngOnInit() {
    if (!this.revisionEntityGetter) {
      this.revisionEntityGetter = (record: any) => record;
    }

    if (this.table) {
      this.cdRef.detectChanges();
      this.columnDefs.forEach(columnDef => {
        this.table.addColumnDef(columnDef);
      });
    }
  }

  cellClass(element: any, fieldName: string) {
    return this.cellClassFn(element, fieldName);
  }
}